import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '@/App';
import CryptoJS from 'crypto-js';
import Modal from '@/components/atomics/Modal';
import Textfield from '@/components/atomics/Textfield';
import Button from '@/components/atomics/Button';
import styles from './ModalAddAdmin.module.scss';
import Select from '@/components/atomics/Select';
import { useAddAmin } from '@/hooks/useAdmin';
import { extractRoleEnum } from '@/utils/admin';
import Spinner from '@/components/atomics/Spinner';

const className = 'modal-add-admin';

type ModalAddAdminProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  loading?: boolean;
  username?: string;
  role?: string;
};

const ModalAddAdmin: React.FC<ModalAddAdminProps> = ({ open, onClose, onSubmit, loading, 
  role: roleProps, username: usernameProps
}) => {
  const [username, setName] = useState<string | undefined>(usernameProps);
  const [password, setPassword] = useState<string | undefined>(undefined);
  const [role, setRole] = useState<string | undefined>(roleProps);
  const appContext = useContext(AppContext);
  const setErrorMessage = appContext?.setErrorMessage ?? (() => {});

  const { data, error, isLoading, refetch } = useAddAmin({
    username: username ?? '',
    password:  password ? CryptoJS.MD5(password).toString() : '',
    level: extractRoleEnum(role ?? '') ?? '',
    method: usernameProps ? 'PUT' : 'POST'
  });
  let errorMessage =
    (error && typeof error === 'object' && 'response' in error && (error as any).response?.data?.message) ||
    (error && typeof error === 'object' && 'data' in error && (error as any).data?.message) ||
    error?.message ||
    '';
  
  useEffect(() => {
    if (data) {
      onSubmit();
    }
  }, [data]);

  useEffect(() => {
    if (errorMessage) {
      setErrorMessage(errorMessage);
    }
  }, [errorMessage]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (usernameProps) {
      if (!username || !role) return;
    } else {
      if (!username || !password || !role) return;
    }
    refetch();
  };

  return (
    <Modal className={styles[isLoading ? className + '__loading' 
      : className]} close={!isLoading} open={open} onClose={onClose}
      title={isLoading ? '' : `${usernameProps ? 'Edit' : 'Tambah'} Admin`}>
      {
        isLoading ? (
          <Spinner />
        ) : (
          <>          
            <div className={styles[className + '__subtitle']}>
              Pastikan Anda mengisi nama username, kata sandi, dan role admin dengan benar.
            </div>
            <form data-testid="addadmin-form" onSubmit={handleSubmit}>
              <Textfield
                disabled={usernameProps ? true : false}
                label="Username *"
                name="name"
                placeholder="Username"
                onChange={e => setName(e.target.value.replace(/ /g, ''))}
                type="text"
                value={username}
              />
              <Textfield
                label="Kata Sandi *"
                name="email"
                placeholder="Kata Sandi"
                onChange={e => setPassword(e.target.value)}
                type="password"
              />
              <Select
                label="Role *"
                name="email"
                placeholder="Pilih Role"
                onChange={e => setRole(e.target.value)}
                options={[
                  {
                    text: 'Supervisor',
                    value: 'Supervisor'
                  },
                  {
                    text: 'CS',
                    value: 'CS'
                  },
                  {
                    text: 'CX',
                    value: 'CX'
                  }
                ]}
                value={role}
              />
              <div style={{ marginTop: 24, display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <Button type="button" onClick={onClose} variant="outline-secondary">
                  Batal
                </Button>
                <Button
                  type="submit"
                  disabled={
                    (!usernameProps && (!username || !password || !role)) ||
                    (usernameProps && (!username || !role)) ? true : false
                  }
                >
                  {loading ? 'Menyimpan...' : 'Simpan'}
                </Button>
              </div>
            </form>
          </>
        )
      }
    </Modal>
  );
};

export default ModalAddAdmin;